var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"width":"200px","position":"absolute","z-index":"20"}},[_c('Float_menu')],1),_c('div',{ref:"Network_all",staticStyle:{"height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }